import React from "react";
import { Download, RefreshCw } from "lucide-react";
import styles from "./WidgetResults.module.css";
import { ButtonDefault } from "@/components/Button/Button";

const WidgetResults = ({ resultImages, onDownload, onTryAgain }) => {
  return (
    <div className={styles.resultsSection}>
      {resultImages.length > 0 ? (
        <div className={styles.resultsList}>
          {resultImages.map((imageUrl, index) => (
            <div key={index} className={styles.resultItem}>
              <img
                src={imageUrl}
                alt={`Результат ${index + 1}`}
                className={styles.resultImage}
              />
              <button
                onClick={() => onDownload(imageUrl)}
                className={styles.downloadButton}
              >
                <Download className={styles.downloadButtonIcon} />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyResults}>
          <p className={styles.emptyResultsText}>Результат появится здесь</p>
        </div>
      )}
      {onTryAgain && (
        <ButtonDefault
          type="button"
          onClick={onTryAgain}
          className={styles.tryAgainButton}
        >
          <RefreshCw className={styles.tryAgainButtonIcon} />
          Сделать ещё одну примерку
        </ButtonDefault>
      )}
    </div>
  );
};

export default WidgetResults;
